import api from '@/os/APIs/utilsAPI';

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$utils = api;
  },
};
